import {
  ACTIVE_SYNC_STATUSES,
  getSyncStatusLabel,
} from "../domain/order-status.js";
import { Icon } from "./Icon.jsx";

function formatTimestamp(value) {
  if (!value) return "Belum pernah berhasil";

  return new Intl.DateTimeFormat("id-ID", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(value));
}

export function SyncStatus({ syncRun }) {
  const status = syncRun?.status;
  const active = ACTIVE_SYNC_STATUSES.has(status);
  const timestamp =
    syncRun?.completed_at || syncRun?.started_at || syncRun?.created_at;

  return (
    <div className={`sync-status sync-status--${status?.toLowerCase() || "none"}`}>
      <span className={active ? "sync-status__icon is-spinning" : "sync-status__icon"}>
        <Icon name={status === "FAILED" ? "warning" : "sync"} size={16} />
      </span>
      <div>
        <strong>{getSyncStatusLabel(status)}</strong>
        <span>{formatTimestamp(timestamp)}</span>
      </div>
    </div>
  );
}

